import { createRoot } from "react-dom/client";
import App from "./App";

console.log('[process.env]', process.env);

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <App />
);
